import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import { store } from './store/index';
import VueAnalytics from 'vue-analytics';
import axios from "axios";
Vue.config.productionTip = false;

axios.get('/ratesdb/getGaKey').then(response => {
  if (response.data != undefined && response.data.length > 0) {
    Vue.use(VueAnalytics, {
      id: response.data,
      router
    });
  }
  new Vue({
    store,
    router,
    render: h => h(App)
  }).$mount("#app");
});

